// Chantier : - (hors chantier structure)
// Regle metier : (securite/infra)
// Decision : D-DEMO-01 (decisions_developpement.md)
// Seule source de la marque consommee par les composants : nom/accroche (src/branding/brand.ts,
// surcharges par VITE_BRANDING_NAME / VITE_BRANDING_TAGLINE) et assets (src/branding/*). Si
// VITE_BRANDING_URL est definie (instance Demo), un kit heberge dans le bucket Storage public
// `branding` remplace les assets et surcharge les tokens CSS a l'execution, sans rebuild : la
// feuille `theme.css` du kit est ajoutee en fin de <head>, apres le CSS du bundle, donc ses
// :root / .dark gagnent par ordre de cascade. Sans variable : comportement strictement identique
// aux assets embarques (Prod, Dev, local).

import { BRAND_DEFAULT } from '@/branding/brand';
import logoDefault from '@/branding/logo.png';
import logoLightDefault from '@/branding/logo-fond-blanc.png';
import heroDefault from '@/branding/hero.webp';

const KIT_URL = import.meta.env.VITE_BRANDING_URL?.replace(/\/+$/, '') || undefined;

const kitAsset = (file: string, fallback: string) => (KIT_URL ? `${KIT_URL}/${file}` : fallback);

export const brand = {
  name: import.meta.env.VITE_BRANDING_NAME || BRAND_DEFAULT.name,
  tagline: import.meta.env.VITE_BRANDING_TAGLINE || BRAND_DEFAULT.tagline,
  logoUrl: kitAsset('logo.png', logoDefault),
  logoLightUrl: kitAsset('logo-fond-blanc.png', logoLightDefault),
  heroUrl: kitAsset('hero.webp', heroDefault),
};

// A appeler une fois au demarrage (main.tsx), avant le rendu React.
export function applyBranding(doc: Document = document) {
  doc.title = brand.name;
  if (!KIT_URL) return;

  const link = doc.createElement('link');
  link.rel = 'stylesheet';
  link.href = `${KIT_URL}/theme.css`;
  doc.head.appendChild(link);

  const icon = doc.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (icon) icon.href = `${KIT_URL}/favicon.png`;
}
